import React, { useState, useEffect } from "react"
import { url_base, getExtension, imageExtensions } from "../../../Helper"
import Arrow from './../../images/icons/drop-down.png'
import Download from './../../images/icons/download.png'
import FileFile from './../../images/icons/file-file.png'

export default ({ show, toggleShow, items, activeI }) => {
  const [activeIndex, setActiveIndex] = useState(activeI || 0)

  function close(e) { e.keyCode === 27 && toggleShow(false) }

  useEffect(() => setActiveIndex(activeI), [activeI])
  useEffect(() => {
    document.body.addEventListener('keydown', close)
    !show && document.removeEventListener('keydown', close)
  }, [show])

  return (
    show ? <div className="fixed flexed fl-c w-100 h-100" style={{ top: 0, left: 0, zIndex: 999 }}>
      <div className="w-100 h-100">
        {/* top */}
        <div className="flexed align-c justify-between bg-top-nav px-32" style={{
          height: 'var(--top-nav-height)'
        }}>
          <div className="flexed align-c">
            <button className="bg-none bd-none text-tomato icon-lg ml-16" style={{ fontSize: '22pt' }}
              onClick={() => toggleShow(false)}>&times;</button>

            <a href={url_base + (items && items[activeIndex]?.file)} target="_blank">
              <img src={Download} alt="" className="icon-md pt-4" />
            </a>
          </div>

          <div>
            {
              items.map((file, index) => (
                imageExtensions.includes(getExtension(file.file)) ?
                  <button key={index} className="px-8 bd-none bg-none"
                    {...(activeIndex !== index ? { style: { transform: 'scale(.8)', opacity: .5 } } : {})}
                    onClick={() => {
                      setActiveIndex(index)
                    }}>
                    <img src={url_base + file.file} alt="" style={{ height: 64 }} />
                  </button> :
                  <button key={index} className="px-8 bd-none bg-none"
                    {...(activeIndex !== index ? { style: { transform: 'scale(.8)', opacity: .5 } } : {})}>
                    <a href={url_base + file.file} target="_blank">
                      <img src={FileFile} alt="" />
                    </a>
                  </button>
              ))
            }
          </div>

          <span className="text-left" style={{ width: 74 }}>{activeIndex + 1} از {items?.length}</span>
        </div>

        {/* image section */}
        <div style={{ background: 'rgba(255, 255, 255, .95)' }}>
          <div className="flexed justify-between container-sm" style={{ height: 'calc(100vh - var(--top-nav-height))' }}>
            {/* pre icon */}
            <button className={"bd-none bg-none " + (activeIndex === 0 && 'op-50')} title="قبلی" onClick={() => {
              if (activeIndex > 0)
                setActiveIndex(activeIndex - 1)
            }}>
              <img className="icon-lg" src={Arrow} alt="" style={{ transform: 'rotate(-90deg)' }} />
            </button>

            <div className="flex-1 overflow-hidden flexed fl-c popIn">
              <img src={url_base + (items && items[activeIndex]?.file)} alt="" className="force h-100" />
            </div>

            {/* next icon */}
            <button className={"bd-none bg-none " + (activeIndex === (items?.length - 1) && 'op-50')} title="بعدی" onClick={() => {
              if (activeIndex < items.length - 1)
                setActiveIndex(activeIndex + 1)
            }}>
              <img className="icon-lg" src={Arrow} alt="" style={{ transform: 'rotate(90deg)' }} />
            </button>
          </div>
        </div>

      </div>
    </div > : <></>
  )
}
